import React, { useEffect, useRef, useState } from "react";
import { AreaChart } from "../../../shared/Charts";

const JobChart = (props) => {
  return <AreaChart data={props.data} />;
};

export default JobChart;
